export default __webpack_public_path__ + "static/media/background-text.6dcb8e5e.png";